import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { useMutation } from '@apollo/react-hooks';
import { injectIntl } from 'react-intl';
import { DELETE_LOCAL_ARI } from '../mutations';
import messages from '../intl-messages';
import { withGrowl } from '../../../../components/GrowlNotifications';


const ManageDelete = ({
  field, currentAccount, intl: { formatMessage }, growl,
}) => {
  const [updateLocalAri] = useMutation(DELETE_LOCAL_ARI, { refetchQueries: ['getAccount'] });
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    setDeleting(false);
  }, [field]);

  return (
    <>
      <div>
        <small>
          {formatMessage(messages.manageDeleteLabel)}
        </small>
      </div>
      <Button
        type="button"
        className="p-button-danger"
        icon={deleting ? 'pi pi-spin pi-spinner' : 'pi pi-times'}
        disabled={deleting}
        onClick={() => {
          const input = {
            accountId: currentAccount,
            ariFieldId: field.id,
          };

          setDeleting(true);
          updateLocalAri({ variables: { input } })
            .then(() => {
              growl.show({
                severity: 'success',
                sticky: false,
                summary: formatMessage(messages.growlAddFieldSuccessSummary),
                detail: formatMessage(messages.growlDeleteAriSuccessDetail),
              });
            })
            .catch(() => {
              growl.show({
                severity: 'error',
                sticky: true,
                summary: formatMessage(messages.growlAddFieldFailSummary),
                detail: formatMessage(messages.growlDeleteAriFailDetail),
              });
              setDeleting(false);
            });
        }}
      />
    </>
  );
};

ManageDelete.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(withGrowl(ManageDelete));
